import classNames from 'classnames';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';
import { fieldHasError } from 'utils/formik/fieldHasError';
import type { NestedFormikName } from 'utils/formik/nestedFormikName';

interface Props<TFormikValues> {
  className?: string;
  formik: FormikProps<TFormikValues>;
  icon?: string;
  name: keyof TFormikValues | NestedFormikName;
}

export const FormikErrorMessage = <TFormikValues,>(
  props: Props<TFormikValues>,
): JSX.Element | null => {
  const hasError = fieldHasError<TFormikValues>(props.formik, props.name);
  if (!hasError) {
    return null;
  }

  return (
    <span className={classNames('formik-error__message', props.className)}>
      {props.icon && <i className={classNames('fa mr-lgu-5', props.icon)} />}
      {props.formik.getFieldMeta(props.name as string).error}
    </span>
  );
};
